import { registerBlockType } from '@wordpress/blocks';
import { InspectorControls, MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import { Button, PanelBody } from '@wordpress/components';
import { useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';


registerBlockType('custom-post-carousel/block', {
    title: 'Insight Carousel',
    icon: 'slides',
    category: 'layout',
    attributes: {
        prevArrow: {
            type: 'object',
            default: null,
        },
        nextArrow : {
            type: 'object',
            default: null,
        },
        insights: {
            type: 'array',
            default: []
        }
    },
    edit: ({ attributes, setAttributes }) => {
    
        const { prevArrow, nextArrow, insights } = attributes;

        const fetchInsights = () => {
            apiFetch({path: `/wp/v2/posts`}).then(res => {
                setAttributes({insights: res});
            })
        }

        useEffect(() => {
            fetchInsights();
        }, []);

        const formatDate = dateString => {
            const date = new Date(dateString);

            const months = [
                "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
                "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
            ];

            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        }

    
        return (
            <>
            <InspectorControls>
                <PanelBody title='Campi expertise'>
                    <h4>Cursore Precendente</h4>
                    <MediaUploadCheck>
                        <MediaUpload 
                            onSelect={image => {
                                setAttributes({prevArrow: image});
                            }}
                            allowedTypes={['image']}
                            value={prevArrow?.id}
                            render={( {open} ) => (
                                <Button className='image-btn' onClick={open}>
                                    Seleziona Cursore Precedente
                                </Button>
                            )}
                        />
                    </MediaUploadCheck>
                    {prevArrow ? <img src={prevArrow.url} style={{maxWidth: '100%', marginTop: '10px'}}/> : ''}
                    <h4>Cursore Successivo</h4>
                    <MediaUploadCheck>
                        <MediaUpload 
                            onSelect={image => {
                                setAttributes({nextArrow: image});
                            }}
                            allowedTypes={['image']}
                            value={nextArrow?.id}
                            render={( {open} ) => (
                                <Button className='image-btn' onClick={open}>
                                    Seleziona Cursore Successivo
                                </Button>
                            )}
                        />
                    </MediaUploadCheck>
                    {nextArrow ? <img src={nextArrow.url} style={{maxWidth: '100%', marginTop: '10px'}}/> : ''}
                </PanelBody>
            </InspectorControls>
            <div className='insights-carousel'>
                {insights.map(insight => (
                    <div className='insight'>
                        <img src={insight.uagb_featured_image_src.full[0]} className='insight-thumbnail'/>
                        <h4>{insight.title.rendered}</h4>
                        <p>{formatDate(insight.date)}</p>
                        <a href={insight.link} className='custom-link' style={{color: '#000000'}}>Leggi di più</a>
                    </div>
                ))}
            </div>
            </>
        );
    },
    save: ({attributes}) => {
        const {prevArrow, nextArrow, insights} = attributes;

        const formatDate = dateString => {
            const date = new Date(dateString);

            const months = [
                "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
                "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
            ];

            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        }
        return (
            <div className='carousel'>
                <div className='carousel-insight'>
                {insights.map(insight => (
                    <div className='insight' key={insight.id}>
                        <img src={insight.uagb_featured_image_src.full[0]} className='insight-thumbnail'/>
                        <div className='insight-info'>
                            <p>{formatDate(insight.date)}</p>
                            <h4>{insight.title.rendered}</h4>
                            <a href={insight.link} className='custom-link'>Leggi di più</a>
                        </div>
                    </div>
                ))}
                </div>
                <div className='carousel-control'>
                    <img className='control-btn prev' src={prevArrow.url} />
                    <img className='control-btn next' src={nextArrow.url} />
                </div>
            </div>
            
        )
    },
});

